import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Icon,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardDivisionSpecialPermissionUX = (props: any) => {
    return(
      <div
        style={{padding: "10px"}}>
        <Form
          id="CardDivisionSpecialPermissionUX-Form-2">
          <FormGroup
            id="CardDivisionSpecialPermissionUX-FormGroup-3"
            inline={true}>
            <FormField
              id="CardDivisionSpecialPermissionUX-FormField-4">
              <Icon
                id="CardDivisionSpecialPermissionUX-Icon-6"
                name="user">
              </Icon>
              <label
                id="CardDivisionSpecialPermissionUX-label-7"
                style={{fontWeight: "normal"}}>
                {props.fullName??"-"}
              </label>
            </FormField>
            <FormField
              id="CardDivisionSpecialPermissionUX-FormField-5">
              <label
                id="CardDivisionSpecialPermissionUX-label-8">
                Affiliation:
              </label>
              <label
                id="CardDivisionSpecialPermissionUX-label-9"
                style={{fontWeight: "normal"}}>
                {props.affiliateName}
              </label>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardDivisionSpecialPermissionUX-div-10"
          style={{color: "rgba(26, 115, 232, 1)", fontWeight: "bold", margin: "-0.25rem 0 0.5rem 0"}}>
          Role & Permission
        </div>
        <div
          id="CardDivisionSpecialPermissionUX-div-11">
          {props.rolePermission}
        </div>
        <div
          id="CardDivisionSpecialPermissionUX-div-12"
          style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end",margin: "1rem 0 0.5rem"}}>

          <div
            id="CardDivisionSpecialPermissionUX-div-13"
            style={{color: "rgba(26, 115, 232, 1)", fontWeight: "bold", }}>
            Division for Patient Operation / Admin menu setting
          </div>
          <div
            id="CardDivisionSpecialPermissionUX-div-14"
            style={{display:props.readOnly?"none":""}}>

            <Button
              color="blue"
              disabled={props.readOnly}
              id="CardDivisionSpecialPermissionUX-Button-15"
              onClick={props.onClickAdd}
              size="small">
              ADD
            </Button>
          </div>
        </div>
        <div
          id="CardDivisionSpecialPermissionUX-div-16"
          style={{width: "100%"}}>

          <Table
            data={props.tableData}
            getTdProps={props.getTdProps}
            headers="Department/Subordinate,Division,Admin Menu,Patient,Active,Del"
            id="CardDivisionSpecialPermissionUX-Table-17"
            keys="affiliate,division,adminMenu,patient,active,action"
            minRows={7}
            resizable={false}
            showPagination={false}
            style={{minHeight: "300px"}}
            widths="^80,^120,^200,70,70,70">
          </Table>
        </div>
        <div
          id="CardDivisionSpecialPermissionUX-div-18"
          style={{display: "flex", justifyContent: "flex-end", marginTop: "1rem"}}>
          {props.buttonSave}
        </div>
      </div>
    )
}


export default CardDivisionSpecialPermissionUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Tue Jul 22 2025 09:23:18 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-Form-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-FormField-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-FormField-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Icon",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-Icon-6"
        },
        "name": {
          "type": "value",
          "value": "user"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.fullName??\"-\""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-label-7"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Affiliation:"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-label-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.affiliateName"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-label-9"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "Role & Permission"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontWeight: \"bold\", margin: \"-0.25rem 0 0.5rem 0\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.rolePermission"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-div-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"flex-end\",margin: \"1rem 0 0.5rem\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "Division for Patient Operation / Admin menu setting"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontWeight: \"bold\", }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{display:props.readOnly?\"none\":\"\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Button",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "ADD"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-Button-15"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickAdd"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 17,
      "name": "Table",
      "parent": 16,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableData"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "headers": {
          "type": "value",
          "value": "Department/Subordinate,Division,Admin Menu,Patient,Active,Del"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-Table-17"
        },
        "keys": {
          "type": "value",
          "value": "affiliate,division,adminMenu,patient,active,action"
        },
        "minRows": {
          "type": "code",
          "value": "7"
        },
        "resizable": {
          "type": "code",
          "value": "false"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{minHeight: \"300px\"}"
        },
        "widths": {
          "type": "value",
          "value": "^80,^120,^200,70,70,70"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSpecialPermissionUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", marginTop: \"1rem\"}"
        }
      },
      "seq": 18,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardDivisionSpecialPermissionUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
